export const cladifyPricingSummary = {
  id: 'pricing_summary',
  name: 'Overall Pricing Summary',
  type: 'pricing',
  subsections: [
    [
      { 
        id: 'first_desc',
        form: {
          component: 'VRichText',
          bind: {
            placeholder: 'Value vs. price section description',
            rows: 3
          }
        },
        display: {
          component: 'VRichTextRenderer'
        },
        value: `<p>
                  Total base price to <mark>supply and install</span> Cladding with Honeycomb Backing Technology is {PRICE_BASE}</mark>.
                </p>
                <small>*Terms: Net 30 days to value of material produced.</small><br/>
                <small>**Above pricing is based on standard details, standard finish, and standard material at today's price.</small>`
      },
      { 
        id: 'content',
        display: {
          component: 'PricingSummaryCladify'
        },
        value: null
      },
      { 
        id: 'desc',
        form: {
          component: 'VRichText',
          bind: {
            placeholder: 'Pricing summary description'
          }
        },
        display: {
          component: 'VRichTextRenderer'
        },
        value: ''
      }
    ]
  ]
}